/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://pixpvkprzzb33ijseefbehzwua.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-p7pmrylgtfdjri2suj5gujvxia",
    "aws_cognito_identity_pool_id": "us-west-2:2757d3e9-8da3-40ad-a111-753591d3fbae",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_pWknmJyR2",
    "aws_user_pools_web_client_id": "n2pij0qouc81ou6a2u84ipsg1",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "dremmaguns-storage-938540a8121244-dev",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
